export class TranslationRequest {
    locale: string ;
    content: TranslationNode;    
}

export class TranslationResponse {
    tpC_KEY_UPPLM: TranslationNode;
}

export class TranslationNode {
    tpc_key_upplm: TranslationContent;    
}

export class TranslationContent {
    translations: ItemsToTranslate;
    
}
export class ItemsToTranslate {
    items: ObjectToTranslate[];
}

export class ObjectToTranslate{
    key: string = '';
    value: string = '';
    constructor(key: string, value: string) {
        this.key = key;
        this.value = value;
    }
}
